/* Reeyah's Hair Place — storefront extras
   - Shows the wholesale popup on the homepage (once per session)
   - Product page and card video autoplay helpers
   Discount rates and totals are decided by admin discounts and shown
   natively by Shopify in cart and checkout; the theme no longer
   computes or displays discount amounts. */
(function () {
  'use strict';

  var POPUP_KEY = 'rhp_ws_popup_seen';

  // ── Popup ──────────────────────────────────────────────────────────────────
  function initPopup() {
    var popup  = document.getElementById('rhp-ws-popup');
    if (!popup) return;

    // Only show on homepage, once per session
    var isHome = document.body.getAttribute('data-template') === 'index' ||
                 window.location.pathname === '/' ||
                 document.querySelector('[data-template="index"]') != null;

    if (!isHome || sessionStorage.getItem(POPUP_KEY)) return;

    function open() {
      popup.removeAttribute('hidden');
      popup.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      popup.setAttribute('hidden', '');
      popup.classList.remove('is-open');
      document.body.style.overflow = '';
      sessionStorage.setItem(POPUP_KEY, '1');
    }

    setTimeout(open, 1500);

    document.getElementById('rhp-ws-close').addEventListener('click', close);
    document.getElementById('rhp-ws-skip').addEventListener('click', close);
    document.getElementById('rhp-ws-overlay').addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
    var cta = document.getElementById('rhp-ws-cta');
    if (cta) cta.addEventListener('click', function () { close(); });
  }

  // ── Product page: auto-play inline video ──────────────────────────────────
  function initProductVideos() {
    function playRhpProductVideos() {
      document.querySelectorAll('.rhp-product-video').forEach(function (v) {
        v.muted = true;
        v.setAttribute('muted', '');
        v.play().catch(function () {});
      });
    }

    // Auto-trigger Dawn's deferred-media load for our video elements
    // so the video appears without requiring a click
    function loadRhpDeferredVideos() {
      document.querySelectorAll('deferred-media.rhp-auto-video').forEach(function (dm) {
        if (dm.hasAttribute('loaded')) return;
        if (typeof dm.loadContent === 'function') {
          dm.loadContent(false);
        }
      });
    }

    // Dawn's pauseAllMedia() calls video.pause() on every <video> on the page,
    // which kills our autoplay. Intercept it and re-play our videos afterwards.
    function hookPauseAllMedia() {
      var orig = window.pauseAllMedia;
      window.pauseAllMedia = function () {
        if (typeof orig === 'function') orig.apply(this, arguments);
        window.setTimeout(playRhpProductVideos, 50);
      };
    }

    function start() {
      hookPauseAllMedia();
      // Wait for Dawn's custom element to be defined before calling loadContent()
      if (window.customElements && customElements.whenDefined) {
        customElements.whenDefined('deferred-media').then(function () {
          loadRhpDeferredVideos();
          window.setTimeout(playRhpProductVideos, 200);
        });
      } else {
        window.setTimeout(function () {
          loadRhpDeferredVideos();
          window.setTimeout(playRhpProductVideos, 200);
        }, 500);
      }
    }

    if (document.readyState === 'complete') {
      start();
    } else {
      window.addEventListener('load', start);
    }
  }

  // ── Card video autoplay ────────────────────────────────────────────────────
  function initCardVideos() {
    if (!('IntersectionObserver' in window)) {
      // Fallback: just try to play all visible videos
      document.querySelectorAll('.rhp-card-video').forEach(function (v) {
        v.play().catch(function () {});
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          if (video.readyState === 0) video.load();
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.1 });

    function observeVideos() {
      document.querySelectorAll('.rhp-card-video:not([data-rhp-vid])').forEach(function (v) {
        v.dataset.rhpVid = '1';
        observer.observe(v);
      });
    }

    observeVideos();

    var grid = document.getElementById('product-grid');
    if (grid) {
      new MutationObserver(observeVideos).observe(grid, { childList: true, subtree: true });
    }
  }

  // ── Init ───────────────────────────────────────────────────────────────────
  function init() {
    initPopup();
    initProductVideos();
    initCardVideos();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
